export default __webpack_public_path__ + "static/bunch-747c2d7473e1a26b5f74903b3fbfab32.png";